import { SvgIcon } from '@material-ui/core';
import React from 'react';

export default function BookIcon() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M3.3335 16.2498V3.74984C3.3335 3.1973 3.55299 2.6674 3.94369 2.2767C4.33439 1.886 4.8643 1.6665 5.41683 1.6665H15.8335C16.0545 1.6665 16.2665 1.7543 16.4228 1.91058C16.579 2.06686 16.6668 2.27882 16.6668 2.49984V17.4998C16.6668 17.7209 16.579 17.9328 16.4228 18.0891C16.2665 18.2454 16.0545 18.3332 15.8335 18.3332H5.41683C4.8643 18.3332 4.33439 18.1137 3.94369 17.723C3.55299 17.3323 3.3335 16.8024 3.3335 16.2498ZM3.3335 16.2498C3.3335 15.6973 3.55299 15.1674 3.94369 14.7767C4.33439 14.386 4.8643 14.1665 5.41683 14.1665H16.6668"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
